<script>
export default {
    name: "ClinicalProfile",

    data() {

        return {
            showAdd: false,
        };
    },

    components: {

        "add-clinical-profile-modal": () => import('./modals/AddClinicalProfile.vue'),
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="md:w-2/3 sm:w-full p-tiny text-right">
        <button class="btn-sm bg-blue-500 whitespace-no-wrap text-white text-xs font-bold" @click.prevent="showAdd=true"><i class="fa fa-plus"></i> Profile</button>
    </div>
    <add-clinical-profile-modal :showModal="showAdd" @closeModal="showAdd=false"></add-clinical-profile-modal>
    <div class="md:w-2/3 sm:w-full">
        <table class="table">
            <thead class="bg-blue-500 text-white text-sm">
                <th class="p-tiny">Profile History</th>
                <th class="p-tiny">Comments</th>
            </thead>
            <tbody class="text-xs">
                <tr>
                    <td class="p-tiny"></td>
                    <td class="p-tiny"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
